module.exports = __webpack_public_path__ + "img/gestoCoracaoComDedos.3f7abf68.png";